import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingOutskirts = function () { return utilBalancing.getBalancing().Outskirts; };
export var selectBalancingOutskirt = memoize(function (id) { return selectBalancingOutskirts().get(id); });
export var selectBalancingOutskirtUnlockLevel = memoize(function (id) {
    var outskirtBuilding = selectBalancingOutskirt(id);
    return outskirtBuilding ? outskirtBuilding.unlockLevel : Number.MAX_VALUE;
});
export var balancingOutskirtsMemoizedFunctions = [
    selectBalancingOutskirts,
    selectBalancingOutskirt,
    selectBalancingOutskirtUnlockLevel,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingOutskirts.ts
// module id = 112
// module chunks = 3